import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  kicker?: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  kicker,
  title,
  subtitle,
  moreTo,
  moreLabel = '查看全部',
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-6">
      <div>
        {kicker ? (
          <span className="inline-flex items-center gap-1.5 text-xs font-label font-medium tracking-widest text-accent-700">
            <i className="ri-shining-2-line"></i>
            {kicker}
          </span>
        ) : null}
        <h2 className="mt-1.5 font-heading text-xl md:text-2xl font-bold text-foreground-950">{title}</h2>
        {subtitle ? <p className="mt-1.5 text-sm text-foreground-600 max-w-2xl">{subtitle}</p> : null}
      </div>
      {moreTo ? (
        <Link
          to={moreTo}
          className="group inline-flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-label font-medium text-primary-700 transition-colors hover:text-primary-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
        </Link>
      ) : null}
    </div>
  );
}